var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7,21c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41V6c-.28,0-.52-.1-.71-.29s-.29-.43-.29-.71.1-.52.29-.71.43-.29.71-.29h4c0-.28.1-.52.29-.71s.43-.29.71-.29h4c.28,0,.52.1.71.29s.29.43.29.71h4c.28,0,.52.1.71.29s.29.43.29.71-.1.52-.29.71-.43.29-.71.29v13c0,.55-.2,1.02-.59,1.41s-.86.59-1.41.59H7Zm0-15v13h10V6H7Zm2,10c0,.28.1.52.29.71s.43.29.71.29.52-.1.71-.29.29-.43.29-.71v-7c0-.28-.1-.52-.29-.71s-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71v7Zm4,0c0,.28.1.52.29.71s.43.29.71.29.52-.1.71-.29.29-.43.29-.71v-7c0-.28-.1-.52-.29-.71s-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71v7ZM7,6v13V6Z"}));
}

Delete.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Delete;

Delete.default = Delete;
